<template>
  <div class="item mb-20" :class="goodIndex%4 === 0 ? '' : 'ml-20'">
    <div class="pic">
      <el-image :src="Utils.IMG_PREV + goodItem.goodsPicList[imgIndex].pic" fit="cover" class="w-100 h-100"></el-image>
      <div class="mask" :class="isSwitch ? 'bg-eeeff3' : 'bg-transparent'"></div>
      <div class="imgList flex align-center">
        <div class="img-item cursor mr-5" :style="{background:'url(' + Utils.IMG_PREV+item.pic + ') no-repeat center/cover'}" v-for="(item, index) in goodItem.goodsPicList" :key="index" @mouseenter="onImg(index)">
          <div class="w-100 h-100" :class="index === imgIndex ? 'bg-c19357-5' : ''"></div>
        </div>
      </div>
    </div>
    <div class="bottom flex-column">
      <div class="color-ff font-16 font-yahei mb-6">{{goodItem.name}}</div>
      <div class="flex align-center mb-28">
        <span class="font-18 color-c19357 font-arial mr-10">¥{{Utils.toFixedNum(goodItem.isPeferential ? goodItem.summaryPreferentialPrice : goodItem.summaryPrice)}}</span>
        <span class="linethrough color-ca font-12 font-arial" v-if="goodItem.isPeferential">¥{{Utils.toFixedNum(goodItem.summaryPrice)}}</span>
      </div>
      <div class="flex align-start justify-space-between flex-1 h-0">
        <div class="font-12 color-94">
          <template v-for="(item,index) in goodItem.programmeSpaceAttributeList">
            <div class="flex align-center mb-4" :key="index" v-if="index < 3">{{item.standard}}<div class="w-130 text-overflow ml-10">{{item.value}}</div></div>
          </template>
          <div class="flex align-center">编码<div class="w-130 text-overflow ml-10">{{goodItem.number}}</div></div>
        </div>
        <el-input-number v-model="goodItem.quantity" @change="changeNumber" :min="1"></el-input-number>
      </div>
    </div>
    <div class="operate">
      <div class="flex align-center">
        <img :src="isSelect ? '/images/xuan-xz.png' : '/images/xuan.png'" alt="" class="cursor" @click="chooseGoods" v-if="goodItem.isEmpty != 1">
        <img src="/images/shanchu.png" alt="" class="cursor ml-10" @click="onDelete" v-if="goodItem.isNew">
      </div>
    </div>
    <img src="/images/wuhuoshangpin.png" alt="" class="mr-5 wuhuo" v-if="goodItem.isEmpty == 1">
  </div>
</template>

<script>

export default {
  name: "Index",
  components: {},
  props: ['index', 'goodIndex', 'isFixed', 'goodItem', 'isShow'],
  data () {
    return {
      num: 0,
      isSelect: false,
      imgIndex: 0,
      isSwitch: false
    }
  },
  created () {},
  mounted () {
    console.log(this.goodItem)
  },
  methods: {
    chooseGoods () {
      this.isSelect = ! this.isSelect
      let item = {
        isSelect: this.isSelect,
        index: this.index,
        goodIndex: this.goodIndex
      }
      this.$emit('on-choose', item)
    },
    onImg (e) {
      this.imgIndex = e
    },
    onDelete () {
      this.$emit('delete')
    },
    changeNumber () {
      this.$emit('on-change')
    }
  },
  watch: {
    imgIndex (e) {
      this.isSwitch = true
      setTimeout(() => {
        this.isSwitch = false
      }, 300)
    }
  }
};
</script>

<style lang="scss" scoped>
  .item{
    width: 335px;
    position: relative;
    .pic{
      height: 220px;
      border-radius: 4px;
      overflow: hidden;
      position: relative;
      .imgList{
        position: absolute;
        z-index: 9;
        bottom: 10px;
        left: 30px;
        .img-item{
          width: 40px;
          height: 26px;
          border: 1px solid #292a2e;
          border-radius: 4px;
          overflow: hidden;
        }
      }
    }
    .mask{
      height: 220px;
      width: 100%;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 8;
      transition: all 1.5s ease;
    }
    .bottom{
      height: 208px;
      border-radius: 4px;
      overflow: hidden;
      background: #292a2e;
      padding: 26px 28px 28px;
    }
    .operate{
      position: absolute;
      right: 10px;
      top: 10px;
      z-index: 9;
    }
  }
  .w-130{
    width: 130px;
  }
  .wuhuo{
    position: absolute;
    left: 0;
    top: 0;
  }

  ::v-deep{
    .el-input__inner{
      height: 30px;
      line-height: 30px;
    }
    .el-input-number .el-input__inner{
      padding: 0 30px;
    }
    .el-input-number{
      align-self: flex-end;
      margin-bottom: 4px;
      width: 90px;
      line-height: 30px;
      border-radius: 20px;
      overflow: hidden;
      .el-input__inner{
        background: rgba($color: #000000, $alpha: 0.4);
        border: 0;
        color: #fff;
      }
    }
    .el-input-number__decrease, .el-input-number__increase{
      width: 30px;
      height: 30px;
      top: 0;
      border: 0;
      background: transparent;
      color: #7d7d7d;
      font-weight: bold;
    }
    .el-input-number__decrease{
      left: 0;
    }
    .el-input-number__increase{
      right: 0;
    }
  }
</style>
